/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_Feat2Inputs */

const en_st_pricing_feat2 = /** @type {(inputs: St_Pricing_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilingual proposal (HTML + PDF)`)
};

const id_st_pricing_feat2 = /** @type {(inputs: St_Pricing_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal dwibahasa (HTML + PDF)`)
};

/**
* | output |
* | --- |
* | "Bilingual proposal (HTML + PDF)" |
*
* @param {St_Pricing_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_feat2 = /** @type {((inputs?: St_Pricing_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_feat2(inputs)
	return en_st_pricing_feat2(inputs)
});